export type { chatDetailsUIState } from './reducer';
export { chatDetailsReducer } from './reducer';
